export default __webpack_public_path__ + "static/book-like-no-other-15fa4d2acbd6b4a62dc42c876f2c4065.png";